import type { IconSvgObject } from './types';

const Behance01Icon: IconSvgObject = [
  ["path", { d: "M7.4 12C9.38823 12 11 10.433 11 8.5C11 6.567 9.38823 5 7.4 5H2V12M7.4 12C9.38823 12 11 13.567 11 15.5C11 17.433 9.38823 19 7.4 19H2V12M7.4 12H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 7H16M14 14H22C22 11.9587 20.2091 10 18 10C15.7909 10 14 11.9587 14 14ZM14 14V15C14 17.2091 15.7909 19 18 19C19.4806 19 20.7733 18.1956 21.4649 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Behance01Icon;
